import { html, unsafeCSS, CSSResultGroup } from "lit";
import { customElement, property } from "lit/decorators.js";
import privateDataBlockStyles from "../../styles/private-data-block.css?inline";
import { Icon } from "../Icon";
import { ApidaeVisualHost } from "../ApidaeVisualHost";

// Import nécessaire pour enregistrer le composant Icon
Icon;

interface PrivateDataItem {
  icon?: string;
  title: string;
  content: string;
}

@customElement("apidae-detail-view-private-data-block")
export class PrivateDataBlock extends ApidaeVisualHost {
  static styles: CSSResultGroup = unsafeCSS(privateDataBlockStyles);

  @property({ type: Array })
  items: PrivateDataItem[] = [];

  render() {
    if (!this.items || this.items.length === 0) {
      return html``;
    }

    return html`
      <section class="private-data-block">
        <div class="private-data-block-grid">
          ${this.items.map(
            (item) => html`
              <article class="private-data-card">
                <div class="private-data-card-header">
                  ${item.icon
                    ? html`
                        <apidae-icon
                          name="${item.icon}"
                          size="20"
                          color="currentColor"
                          .visualCustomization=${this.visualCustomization}
                        ></apidae-icon>
                      `
                    : ""}
                  <h4 class="private-data-card-title">${item.title}</h4>
                </div>
                <p class="private-data-card-content">${item.content}</p>
              </article>
            `,
          )}
        </div>
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "apidae-detail-view-private-data-block": PrivateDataBlock;
  }
}
